<template>
  <card-component title="Servicios" :subtitle="subtitle" class="has-table has-mobile-sort-spaced">
    <div slot="headerRight" class="card-header-icon">
      <div class="columns">
        <div class="column">
          <!-- <horse-table-filter @filtered="applyFilter"/> -->
        </div>
      </div>
    </div>
    <b-table
      slot="content"
      :loading="isLoading"
      :per-page="perPage"
      :striped="isStriped"
      :hoverable="hoverable"
      :data="services"
      :total="totalData"
      :current-page.sync="currentPage"
      paginated
      backend-pagination
    >
      <template slot-scope="props">
        <b-table-column label="Nombre" field="name" >
          <p><b>{{props.row.name}}</b></p>
        </b-table-column>

        <b-table-column label="Fecha Inicio" field="name" >
          <p>{{ moment(props.row.start_date) | moment('LL') }}</p>
        </b-table-column>
        <b-table-column label="Fecha Termino" field="name" >
          <p>{{ moment(props.row.end_date) | moment('LL') }}</p>
        </b-table-column>
        <b-table-column label="N° Caballos" field="name" >
          <p>{{ props.row.taskUsersCount }}</p>
        </b-table-column>
        <b-table-column label="Estado" field="name" >
          <b-tag type="is-light" v-if="props.row.service_status_id === 1">Pendiente</b-tag>
          <b-tag type="is-primary" v-else-if="props.row.service_status_id === 2">En Curso</b-tag>
          <b-tag type="is-info" v-else-if="props.row.service_status_id === 3">Finalizado</b-tag>
        </b-table-column>
        <!-- <b-table-column label="Costo Total" field="name" >
          <p>{{props.row.cost}}</p>
        </b-table-column> -->

        <b-table-column custom-key="actions" class="is-actions-cell">
          <div class="buttons is-right">
            <b-button type="is-success" size="is-small" @click="$emit('edit', props.row.id)">
              Editar
            </b-button>
            <router-link :to="{name:'ironwork.detail', params: {id: props.row.id}}" :class="['button is-small', 'is-primary']">
              Ver detalles
            </router-link>
          </div>
        </b-table-column>
      </template>
      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Cargando Caballos...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="horseshoe" size="is-large" />
            </p>
            <p>No hay registros de Caballos&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </card-component>
</template>

<script>
import ServiceService from '@/services/ServiceService'
import CardComponent from '@/components/CardComponent'

export default {
  props: {
    reload: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CardComponent
  },
  created () {
    this.getServices()
  },
  data () {
    return {
      services: [],
      paginated: true,
      perPage: 10,
      currentPage: 1,
      totalData: 0,
      isStriped: true,
      isNarrowed: false,
      hoverable: true,
      isFocusable: false,
      isLoading: false,
      hasMobileCards: true,
      filters: null
    }
  },
  methods: {
    applyFilter (data) {
      this.filters = data
      this.getServices()
    },
    async getServices () {
      let params = {
        'include[0]': 'status',
        'per_page': this.perPage,
        'page': this.currentPage,
        'detail': true,
        ...this.filters
      }
      this.isLoading = true
      let response = await ServiceService.getServices(params)
      this.services = response.data.data
      this.totalData = response.data.meta.total
      this.isLoading = false
    }
  },
  computed: {
    subtitle () {
      let dataLenght = this.totalData
      let plural = dataLenght === 1 ? '' : 's'
      return `${dataLenght} Servicio${plural} Herraje${plural} registrado${plural}`
    }
  },
  watch: {
    currentPage (value) {
      this.getServices()
    },
    reload (value) {
      if (value === true) {
        this.getServices()
      }
      this.$emit('update:reload', false)
    }
  }
}
</script>
